import CIMSComment from 'components/CIMSComment'
import CIMSFormItem from 'components/CIMSFormItem'
import { useWorkflowRollbackComment } from 'components/CIMSComment/hooks/useWorkflowRollbackComment'

const Comments: React.VFC = () => {
  return (
    <CIMSFormItem {...useWorkflowRollbackComment()}>
      <CIMSComment />
    </CIMSFormItem>
  )
}

export default Comments
